import { FC, useMemo } from 'react';
import { SCUIGeneralModal } from '../../../../atomic/molecules';
import { Grid, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IMGSEARCHV2 } from '../../imageSearchV2.classes';
import { BATCH_SEARCH_LIMIT } from '../../ImageSearchV2.helper';

export const SCUIImageBatchSearchModalV2: FC<{
    open: boolean;
    onClose: any;
    searchedText: any;
    setSearchedText: any;
    listele?: any;
    text?: any;
}> = ({ open, onClose, searchedText, setSearchedText, listele, text }) => {
    const { t } = useTranslation();

    const itemCount = useMemo(() => {
        if (!searchedText?.trim()) return 0;
        return searchedText
            .trim()
            .split('\n')
            .filter((line: string) => line.trim() !== '').length;
    }, [searchedText]);

    const isOverLimit = itemCount > BATCH_SEARCH_LIMIT;

    return (
        <SCUIGeneralModal
            width={'xs'}
            open={open}
            onClose={onClose}
            title={t('general.batchSearch')}
            functionButtonOnClick={listele}
            buttonText={t('general.search')}
            disabled={isOverLimit}
        >
            <Grid container className={IMGSEARCHV2.batchModalBody} sx={{ padding: '2rem' }}>
                <TextField
                    className={IMGSEARCHV2.inputTextareaBatchCodes}
                    sx={{ paddingBottom: '0.5rem' }}
                    label={text}
                    value={searchedText}
                    multiline
                    rows={10}
                    onChange={(event: any) => {
                        setSearchedText(event.target.value);
                    }}
                    slotProps={{ inputLabel: { shrink: true } }}
                    fullWidth
                    error={isOverLimit}
                />
                <Grid container className={IMGSEARCHV2.batchModalHintsRow} justifyContent="space-between" alignItems="center" sx={{ mt: 0.5 }}>
                    <Typography
                        variant="caption"
                        color={isOverLimit ? 'error' : 'text.secondary'}
                        fontWeight={isOverLimit ? 600 : 400}
                    >
                        {isOverLimit
                            ? t('imageSearchV2.batchSearchLimitWarning', {
                                  max: BATCH_SEARCH_LIMIT,
                                  count: itemCount,
                              })
                            : ''}
                    </Typography>
                    <Typography
                        variant="caption"
                        color={isOverLimit ? 'error' : 'text.secondary'}
                        fontWeight={isOverLimit ? 600 : 400}
                    >
                        {t('imageSearchV2.batchSearchItemCount', {
                            count: itemCount,
                            max: BATCH_SEARCH_LIMIT,
                        })}
                    </Typography>
                </Grid>
            </Grid>
        </SCUIGeneralModal>
    );
};
